import React from 'react';

const ShopTheLook = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-2">Shop the look</h2>
        <p className="text-gray-600">Explore the Latest Fashion Trends: Shop Stylish Clothing and Accessories</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="relative group overflow-hidden rounded-lg">
          <img
            src="https://images.pexels.com/photos/2043590/pexels-photo-2043590.jpeg?auto=compress&cs=tinysrgb&w=800"
            alt="Shop look 1"
            className="w-full h-[500px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition">
            <span className="text-2xl">+</span>
          </button>
        </div>

        <div className="relative group overflow-hidden rounded-lg">
          <img
            src="https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=800"
            alt="Shop look 2"
            className="w-full h-[500px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition">
            <span className="text-2xl">+</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ShopTheLook;
